import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionOption } from '@core/models';
import { LayoutService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { closeDialogOnEscape } from '@shared/helpers';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-leave-info-action-item-templates',
    templateUrl: './leave-info-action-item-templates.component.html',
    styleUrl: './leave-info-action-item-templates.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeaveInfoActionItemsTemplatesComponent {
  static readonly componentName = 'LeaveInfoActionItemsTemplatesComponent';
  
  public form: UntypedFormGroup;
  public position = position;
  public onDragEnded = onDragEnded;

  public isMobile$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      options: SelectionOption[],
      sysText: any
    },
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LeaveInfoActionItemsTemplatesComponent>,
    private layoutService: LayoutService
  ) { 
    this.form = this.fb.group({
      actionItemsTemplate: [null]
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();

    closeDialogOnEscape(this.dialogRef, null, () => this.close());
  }

  public onSubmit() {
    this.dialogRef.close({templateId: this.form.controls.actionItemsTemplate.value, saved: true});
  }

  public close(): void {
    this.dialogRef.close({templateId: null, saved: false});
  }

}
